import { useState } from 'react';
import { useCallback } from 'react';
import { ChangeEvent } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  AsyncRequestProgress,
  appSelectors,
  createCollection,
} from '../../redux/appSlice';
import { useEffect } from 'react';

interface CreateCollectionFormProps {
  close: () => void;
}

export const CreateCollectionForm = ({ close }: CreateCollectionFormProps) => {
  const dispatch = useAppDispatch();
  const loggedIn: boolean = useAppSelector(appSelectors.isLoggedIn);
  const [newCollectionName, setNewCollectionName] = useState<string>('');

  const createCollectionLoadingState: AsyncRequestProgress = useAppSelector(
    appSelectors.createCollectionLoadingState
  );

  useEffect(() => {
    if (
      createCollectionLoadingState.loadingState === 'succeeded' &&
      createCollectionLoadingState.result
    ) {
      close();
    }
  }, [createCollectionLoadingState, close]);

  const handleNewCollectionNameChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    setNewCollectionName(event.target.value);
  };

  const handleCreateCollectionClick = useCallback(() => {
    if (newCollectionName) {
      dispatch(createCollection(newCollectionName));
    }
  }, [newCollectionName, dispatch]);

  return (
    <div className="collection-create-content">
      {loggedIn && (
        <>
          <input
            value={newCollectionName}
            placeholder="Collection name"
            onChange={handleNewCollectionNameChange}
            disabled={createCollectionLoadingState.loadingState === 'pending'}
          />
          <button
            onClick={handleCreateCollectionClick}
            disabled={createCollectionLoadingState.loadingState === 'pending'}
          >
            Create collection
          </button>
          {createCollectionLoadingState.loadingState === 'failed' && (
            <p className="error-message">
              Failed to create your new collection
            </p>
          )}
        </>
      )}
      {!loggedIn && <p>You aren't logged in</p>}
    </div>
  );
};
